import { render, staticRenderFns } from "./project-attendant-score.vue?vue&type=template&id=0fa9838a"
import script from "./project-attendant-score.vue?vue&type=script&lang=js"
export * from "./project-attendant-score.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports